import { filterTypes } from '@/constants/Srp'
import { formatCurrency } from '@/utils'
import { Container, Typography } from '@cleartrip/ct-design-components'
import { useEffect, useState } from 'react'
import InputRange from 'react-input-range-rtl'
import FilterCategory from './FilterCategory'
import RangeSlider from './RangeSlider'

const TotalRoundTripPrice = (props: any) => {
  const { currentPrice, minPrice, maxPrice, onFilterChange, isRevamp = false } = props
  const [price, setPrice] = useState<number>(currentPrice)
  const [step, setStep] = useState(100)

  useEffect(() => {
    if (currentPrice !== price) setPrice(currentPrice)
  }, [currentPrice])

  const onValueChange = (value: any) => {
    setPrice(value)
    const diffPriceFromMax = value - maxPrice
    if (diffPriceFromMax < 100 && step > 99) {
      setStep(1)
    }
  }

  return (
    <FilterCategory
      count={currentPrice < maxPrice ? 1 : 0}
      isRevamp={isRevamp}
      title='Total roundtrip price'
      onClear={() => onFilterChange(filterTypes.TOTAL_ROUND_TRIP_PRICE, maxPrice)}
    >
      <Container
        className={isRevamp ? 'flex flex-column' : 'pl-1 pb-3 intl_inputRange'}
        style={isRevamp ? undefined : { width: '90%' }}
      >
        <Typography variant={isRevamp ? 'P2' : 'B2'} color='subheading' className='flex pb-3'>
          Upto:{' '}
          <Typography variant={isRevamp ? 'P2' : 'L2'} color='primary' className='c-primary pl-1'>
            {formatCurrency(price)}
          </Typography>
        </Typography>
        {isRevamp ? (
          <RangeSlider
            ariaLabel='Total round trip price'
            max={maxPrice}
            min={minPrice}
            value={price}
            onChange={onValueChange}
            onChangeComplete={value => onFilterChange(filterTypes.TOTAL_ROUND_TRIP_PRICE, value)}
          />
        ) : (
          <InputRange
            minValue={minPrice}
            maxValue={maxPrice}
            value={price}
            onChange={onValueChange}
            onChangeComplete={(value: any) => onFilterChange(filterTypes.TOTAL_ROUND_TRIP_PRICE, value)}
            step={step}
            maxLabel=''
            minLabel=''
          />
        )}
      </Container>
    </FilterCategory>
  )
}

export default TotalRoundTripPrice
